<template>
  <v-snackbar
    v-model="isVisible"
    :color="color"
    timeout="-1"
  >
    {{ notification.text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        text
        v-bind="attrs"
        @click="isVisible = false"
      >
        Fermer
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TheNotificationSnackbar',

  computed: {
    ...mapState(['notification']),

    isVisible: {
      get() {
        return this.notification.isVisible;
      },
      set(val) {
        this.$store.commit('SET_NOTIFICATION', { isVisible: val, text: '', color: '' });
      },
    },

    color() {
      return this.notification.color;
    },
  },
};
</script>
